import * as Yup from 'yup';

// The roadmap builder has no single date field — each column carries its own
// free-text `period` ("Q2 2025"), so only the title/description are validated here.
const AddEditRoadMapValidation = Yup.object().shape({
  heading: Yup.string().trim().required('Please enter a heading.'),
  description: Yup.string().trim().required('Please enter a description.')
});

export default AddEditRoadMapValidation;
